export default {
  isPaas: false,
  disableSatismetter: false,
  disableUsetiful: false,
  marketingActivated: false,
  doNotDisplayLogoNColorsSettings: false,
};
